// React Imports
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import vegzelma from "../assets/img/home-banner/vegzelma-home-banner.png";
import adalimumab from "../assets/img/home-banner/adalimumab-home-banner.png";
import avtozma from "../assets/img/home-banner/avtozma-home-banner.png";
import yuflyma from "../assets/img/home-banner/yuflyma-home-banner.png";
import Zymfentra from "../assets/img/home-banner/zymfentra-home-banner.png";
import steqyema from "../assets/img/home-banner/steqeyma-home-banner.png";
import osenvelt from "../assets/img/home-banner/osenvelt-home-banner.png";
import stoboclo from "../assets/img/home-banner/stoboclo-home-banner.png";
import peoples from "../assets/img/cover-new.png";

const Home = () => {
  return (
    <section className="home home1">
      <div className="title-text d-lg-none">
        <h1>
          CELLTRION CARES
          <span>
            <sup>&reg;</sup>
          </span>{" "}
          <span className="text-p">CO-PAY PROGRAM</span>
        </h1>
      </div>

      <div className="new-home-people">
        <img src={peoples} alt="people" />
      </div>
      <Container className="h-100">
        <div className="home-text next">
          <div className="">
            <div className="title-text d-none d-lg-flex">
              <h1>
                CELLTRION CARES
                <span>
                  <sup>&reg;</sup>
                </span>
              </h1>
              <p>CO-PAY PROGRAM</p>
            </div>
            <div className="title-desc">
              Provides financial assistance to eligible patients using
              commercial insurance
            </div>
            <div className="title-desc-mobile">
              Provides financial assistance <br /> to eligible patients <br />{" "}
              using commercial insurance
            </div>
          </div>
          <div className="green-banner">
            Select your prescribed medication to learn more and check your
            eligibility
          </div>
          <div>
            <Row
              xs={1}
              md={2}
              lg={2}
              className="products"
              style={{ justifyContent: "center" }}
            >
              <Col className="single-product">
                <div className="product-inner">
                  <a href="/entry/adalimumab">
                    <img src={adalimumab} alt="Adalimumab" />
                  </a>
                </div>
              </Col>
              <Col className="single-product" style={{ paddingRight: "15px" }}>
                <div className="product-inner">
                  <a href="/entry/avtozma">
                    <img src={avtozma} alt="Avtozma" />
                  </a>
                </div>
              </Col>
              <Col className="single-product">
                <div className="product-inner">
                  <a href="/entry/osenvelt">
                    <img src={osenvelt} alt="Osenvelt" />
                  </a>
                </div>
              </Col>

              <Col className="single-product" style={{ paddingRight: "15px" }}>
                <div className="product-inner">
                  <a href="/entry/steqeyma">
                    <img src={steqyema} alt="Steqeyma" />
                  </a>
                </div>
              </Col>

              <Col className="single-product">
                <div className="product-inner">
                  <a href="/entry/stoboclo">
                    <img src={stoboclo} alt="Stoboclo" />
                  </a>
                </div>
              </Col>

              <Col className="single-product" style={{ paddingRight: "15px" }}>
                <div className="product-inner">
                  <a href="/entry/vegzelma">
                    <img src={vegzelma} alt="Vegzelma" />
                  </a>
                </div>
              </Col>

              <Col className="single-product" style={{ paddingRight: "15px" }}>
                <div className="product-inner">
                  <a href="/entry/zymfentra">
                    <img src={Zymfentra} alt="Zymfentra" />
                  </a>
                </div>
              </Col>

            </Row>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Home;
